import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { CodeHighlightComponent } from '../code-highlight/code-highlight.component';
import { TabFooterComponent } from '../tab-footer/tab-footer.component';

@Component({
  standalone: true,
  selector: 'mode-dataview-query',
  imports: [CodeHighlightComponent, CommonModule, TabFooterComponent],
  templateUrl: './dataview-query.component.html',
  styleUrls: ['./dataview-query.component.scss'],
})
export class DataviewQueryComponent {
  @Input() connectionName? = '';
  @Input() connectionType? = '';
  @Input() isRawQuery = false;
  @Input() rawQuery = '';
  @Input() renderedQuery = '';
}
